import React from 'react';

const ReorderIcon = () => (
  <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 0.5C15.3125 0.5 16 1.1875 16 2V4C16 4.84375 15.3125 5.5 14.5 5.5H1.5C0.65625 5.5 0 4.84375 0 4V2C0 1.1875 0.65625 0.5 1.5 0.5H14.5ZM14.5 2H10V4H14.5V2ZM14.5 7.5C15.3125 7.5 16 8.1875 16 9V11C16 11.8438 15.3125 12.5 14.5 12.5H1.5C0.65625 12.5 0 11.8438 0 11V9C0 8.1875 0.65625 7.5 1.5 7.5H14.5ZM14.5 9H6V11H14.5V9Z"
      fill="#667085"
    />
  </svg>
);
export default ReorderIcon;
